import React, { useRef, useState } from 'react'
import HealthPortalPhoto from '../../Photos/Group 1068 (1).png'
import PortalButton from '../../Photos/ButtonPortal.png'
import Icon1 from '../../Photos/Crea tu perfil.png'
import Icon2 from '../../Photos/Mide tus riesgos.png'
import Icon3 from '../../Photos/Conoce tu ruta del bienestar.png'
import Icon4 from '../../Photos/Compra tu orden.png'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import Vista1 from '../../Photos/Group 1069.png'
import Vista2 from '../../Photos/Evalua tu estado.png'
import Vista3 from '../../Photos/Informe de salud.png'
import Vista4 from '../../Photos/OrdenMedica.png'
import backgroundImage  from '../../Photos/BackgroundHealthPortal.png'
import { motion } from "framer-motion";
import { useInView } from 'react-intersection-observer'

 const itemVariants = {

        hidden: { opacity: 0, y: 40 },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 1.2,
            ease: "easeOut",
          },
        },
      };
      
      const containerVariants = {
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.3,
          },
        },
      };

function HealthPortal() {
  const swiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const goToSlide = (index) => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideTo(index);
      setActiveIndex(index);
    }
  };

  const { ref, inView } = useInView({
      triggerOnce: true,
      threshold: 0.2,
    });
  
  return (
    <div style={{ backgroundImage: `url(${backgroundImage})` , backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat', backgroundPositionY: '-22rem' }}>
      <motion.div   ref={ref}
        variants={containerVariants}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}>  
        <div className='HealthPortalFlex'>
        <motion.div variants={itemVariants} className='HealthPortalGroup' style={{padding:'0'}}> 
        <img className='HealthPortalGroupImage' src={HealthPortalPhoto}/>
        </motion.div>
        <div className='HealthPortalGroup'>    
         
        <motion.div variants={itemVariants} className='HealthPortalTopTitle'>Portal de Salud</motion.div>
<motion.div className='HealthPortalTitle' variants={itemVariants}> 
        +YMC es un portal de <span><b>salud inteligente </b></span> diseñado para
facilitarte el acceso a una <span><b>medicina preventiva, oportuna y eficaz.</b></span>
</motion.div>
<motion.div variants={itemVariants} className='HealthPortalSubTitle'>
¡Tomar el control de tu salud, nunca fue tan fácil! </motion.div>
      
       <a href="https://salud.yomecontrolo.cl/" style={{ textDecoration: 'none' }}>
 <div className='GeneralPurpleButtonFlex PurpleButtonBlock' style={{marginInline:'auto'}}> 
        <div className='PurpleButtonText'>
          Ir al portal de Salud +YMC
        </div>
        <div   className='PurpleButtonIconPortal'>
          <img src={PortalButton}/>
        </div>
      
        </div>
        </a>
      </div>
      </div>
    </motion.div>
    
<div className='HealthPortalItemsGroup'>
<div className='HealthPortalItem' onClick={() => goToSlide(0)} style={{backgroundColor:'#EFEFFF', border: activeIndex === 0 ? '3px solid #10DEFF' : ''}} >
  <div>1.</div>
  <img src={Icon1}/>
 <div>Crea tu perfil médico </div> 
</div>
<div className='HealthPortalItem' onClick={() => goToSlide(1)} style={{backgroundColor:'#CFF9FF', border: activeIndex === 1 ? '3px solid #10DEFF' : ''}} >
<div>2.</div>
  <img src={Icon2}/>
 <div>Mide tu riesgo de salud</div> 
</div>
<div className='HealthPortalItem' onClick={() => goToSlide(2)} style={{color:'#FBFFFF',backgroundColor:'#6633FF', border: activeIndex === 2 ? '3px solid #10DEFF' : ''}} >
<div  >3.</div>
  <img src={Icon3}/>
 <div>Evalúa tus resultados</div> 
</div>
<div className='HealthPortalItem' onClick={() => goToSlide(3)} style={{backgroundColor:'#CCCCFF', border: activeIndex === 3 ? '3px solid #10DEFF' : ''}}
 >
<div>4.</div>
  <img src={Icon4}/>
 <div>Genera una orden de exámenes preventivos</div> 
</div>
</div>

<div className='HealthPortalSwiper'> 
<Swiper
        ref={swiperRef}
        modules={[Autoplay]}
        autoplay={{ delay: 3500, disableOnInteraction: false }}
        loop={true}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)} 
      >
        <SwiperSlide><img src={Vista1} alt="Imagen 1" /></SwiperSlide>
        <SwiperSlide><img src={Vista2} alt="Imagen 2" /></SwiperSlide>
        <SwiperSlide><img src={Vista3} alt="Imagen 3" /></SwiperSlide>
        <SwiperSlide><img src={Vista4} alt="Imagen 3" /></SwiperSlide>

      </Swiper>
      </div>



    </div>
  )
}
export default HealthPortal;